import {
  QuestionnaireGroupResponse,
  SelectionRequest,
} from '@tiendanube/common';

interface Params {
  currentStep: number;
  response: { options: QuestionnaireGroupResponse[] };
  currentGroup: QuestionnaireGroupResponse;
  currentValues: SelectionRequest[];
}

export function getNextStepIndex({
  currentStep,
  response,
  currentGroup,
  currentValues,
}: Params): number {
  const selectedId = currentValues[0]?.domain_mapping_id;
  const selectedCode = currentGroup.types.find(
    (t) => t.id === selectedId,
  )?.code;
  const jumpToOn = currentGroup.jumpToOn;

  let jumpTarget: string | undefined;

  if (!selectedId && jumpToOn?.empty) {
    jumpTarget = jumpToOn.empty;
  } else if (selectedCode?.startsWith('skip') && jumpToOn?.skip) {
    jumpTarget = jumpToOn.skip;
  } else if (selectedCode && jumpToOn?.[selectedCode]) {
    jumpTarget = jumpToOn[selectedCode];
  }

  if (jumpTarget) {
    const targetIndex = response.options.findIndex(
      (opt) => opt.group === jumpTarget,
    );
    return targetIndex >= 0 ? targetIndex : currentStep + 1;
  }

  return currentStep + 1;
}
